export const getNft = (request) => {
    const API_ENDPOINT = 'https://jsonplaceholder.typicode.com/todos/'
    const parameters = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    };
    return fetch(API_ENDPOINT, parameters)
      .then(response => {
        return response.json();
      })
      .then(json => {
        return json;
      });
}